/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { IMigrationState } from "./types";

export const initialState: IMigrationState = {
  loginRequest: {
    username: "",
    password: "",
    hostAddress: "",
  },
  devices: [],
  isConnected: false,
  initialMigrationData: [],
};
